let projects = [
  {
    title: 'Job Hunt',
    deployedLink: 'https://job-hunt-client.vercel.app/landing',
    imgSrc: '/jobhunt.jpg',
    description:
      'Full stack web application for tracking job application and status ',
    techStack: ['MERN'],
  },
  {
    title: 'Pet SOS',
    deployedLink: 'https://lost-and-found-35cde.web.app',
    imgSrc: '/petSOS.png',
    description:
      'Lost and found app for reporting lost pets.',
    techStack: ['React','Tailwind','YupForm', 'Firebase'],
  },
  {
    title: 'Monster-x-lab',
    deployedLink: 'https://monster-xlab-client.vercel.app/',
    imgSrc: '/monsterxlab.jpg',
    description: 'Customisable 3D toy model with public gallery section',
    techStack: ['MERN', 'ThreeJS', 'React3Fiber', 'Cloudinary'],
  },
  {
    title: 'Resu(ME)',
    deployedLink: 'https://samson-resume.vercel.app/',
    imgSrc: '/resume.jpg',
    description: 'Interactive 3D website with realistic avatar and resume',
    techStack: ['ReactJS', 'ThreeJS', 'React3Fiber', 'React3Drei'],
  },
  {
    title: 'Portfolio',
    deployedLink: 'https://samson-img.vercel.app/',
    imgSrc: '/samsonimg.jpg',
    description: 'Multi page react site created for practice',
    techStack: ['ReactJS'],
  },

  {
    title: 'Spotify Popularity Contest',
    deployedLink: 'https://spotify-popularity.vercel.app/',
    imgSrc: '/spotifypopularity.jpg',
    description:
      'Simple mini game where player guesses which artist has the most followers. Made with SpotifyAPI',
    techStack: ['ReactJS', 'ReactMUI', 'SpotifyAPI'],
  },
  {
    title: 'Fuji Instax Mini Scroll Website',
    deployedLink: 'https://scrollwebsite.vercel.app/',
    imgSrc: '/scroll.jpg',
    description:
      'Interactive scroll based website highlighting the best parts about the Fuji Instax Mini ',
    techStack: ['ReactJS', 'ThreeJS', 'React3Fiber', 'React3Drei', 'GSAP'],
  },

  {
    title: 'Cafe(WIP)',
    deployedLink: 'https://cafe-website-cyan.vercel.app/',
    imgSrc: '/cafe.jpg',
    description: 'Interactive 3D cafe website ',
    techStack: ['ReactJS', 'ThreeJS', 'React3Fiber', 'React3Drei'],
  },
]
export default projects
